import { render } from "./OrgProfileProposalsList.vue?vue&type=template&id=13f6a405"
import script from "./OrgProfileProposalsList.vue?vue&type=script&lang=js"
export * from "./OrgProfileProposalsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__